import { useCallback, useEffect, useState } from 'react'

const STORAGE_KEY = 'viridia-onboarding-progress'

export function useProgress() {
  const [done, setDone] = useState<string[]>([])

  useEffect(() => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY)
      if (raw) setDone(JSON.parse(raw) as string[])
    } catch {
      /* progress is a convenience only */
    }
  }, [])

  const toggle = useCallback((id: string) => {
    setDone((prev) => {
      const next = prev.includes(id)
        ? prev.filter((item) => item !== id)
        : [...prev, id]
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
      } catch {
        /* ignore */
      }
      return next
    })
  }, [])

  const isDone = useCallback((id: string) => done.includes(id), [done])

  return { done, isDone, toggle }
}
